import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Dialog from 'quasar/src/plugins/Dialog.js';;

/**
 * Custom confirm modal.
 * @param {function} onOK
 * @param {string} message
 * @param {Object} options
 * @returns {DialogChainObject}
 */
var confirm = function confirm(onOK) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Are you sure?';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opt = _objectSpread({
    message: message,
    cancel: true,
    persistent: false
  }, options);
  return Dialog.create(opt).onOk(function () {
    onOK();
  });
};
export default confirm;